export interface PaginationState {
  pageNumber: number;
}

const pageNumber = 0;

export const initialPaginationState: PaginationState = {
  pageNumber: pageNumber
};
